import { useRef } from 'react'

import DownArrow from '../../icons/downArrow.inline.svg'

import styles from './nativeSelect.module.scss'

interface NativeSelectProps<V = string> {
  options: { label: string; value: V }[]
  onChange: (value: V) => void
  selectedValue?: V
  placeholder?: string
}

const NativeSelect = ({ options, onChange }: NativeSelectProps) => {
  const selectRef = useRef<HTMLSelectElement | null>()

  return (
    <div
      onClick={() => {
        selectRef.current?.click()
      }}
      className={styles.selectWrapper}
    >
      <select
        className={styles.select}
        ref={ref => {
          selectRef.current = ref
        }}
        onChange={event => {
          onChange(event.target.value)
        }}
        onClick={e => {
          e.stopPropagation()
        }}
      >
        {options.map(option => {
          return (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          )
        })}
      </select>
      <DownArrow className={styles.arrow} />
    </div>
  )
}

export default NativeSelect
